import { render, staticRenderFns } from "./SublimesQuotatorNonProportional.vue?vue&type=template&id=2f509c89&scoped=true&"
import script from "./SublimesQuotatorNonProportional.vue?vue&type=script&lang=js&"
export * from "./SublimesQuotatorNonProportional.vue?vue&type=script&lang=js&"
import style0 from "./SublimesQuotatorNonProportional.vue?vue&type=style&index=0&id=2f509c89&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f509c89",
  null
  
)

export default component.exports